import React from 'react';
import PropTypes from 'prop-types';
import SelectNestedMenuDialog from './common/SelectNestedMenuDialog';
import { webToolNestedMenu } from '../../../../constants/SidebarValues';

const SelectWebToolDialog = (props) => (
  <SelectNestedMenuDialog
    {...props}
    title="導入ウェブツールを選択"
    nestedMenu={webToolNestedMenu}
    colCount={3}
  />
);

SelectWebToolDialog.propTypes = {
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  set: PropTypes.object,
  save: PropTypes.func.isRequired,
};

export default SelectWebToolDialog;



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectNestedMenuDialog/SelectWebToolDialog.jsx